import React from 'react';
import { useTranslatedContent } from '../../../i18n/hooks/useTranslatedContent';
import { Sparkles, Database, Shield, CheckCircle, ArrowRight } from 'lucide-react';

const MigrationProcess: React.FC = () => {
  const { t } = useTranslatedContent('migration');
  const steps = t('process.steps', { returnObjects: true });

  if (!Array.isArray(steps)) return null;

  const stepIcons = [Sparkles, Database, Shield, CheckCircle];

  return (
    <div className="relative">
      <div className="text-center mb-16">
        <h3 className="text-2xl font-semibold text-gray-900">{t('process.title')}</h3>
        <p className="mt-4 text-gray-600 max-w-3xl mx-auto">{t('process.description')}</p>
      </div>

      <div className="relative">
        <div className="absolute top-1/2 left-0 right-0 h-0.5 bg-gradient-to-r from-blue-200 via-indigo-300 to-violet-200 transform -translate-y-1/2 hidden lg:block" />

        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => {
            const Icon = stepIcons[index % stepIcons.length];
            return (
              <div key={index} className="relative group">
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-gradient-to-r from-blue-500 to-violet-500 text-white w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold">
                  {index + 1}
                </div>

                <div className="pt-8 p-6 bg-white rounded-2xl shadow-lg border border-gray-100 hover:shadow-xl transition-shadow duration-300">
                  <div className="flex flex-col items-center text-center">
                    <div className="p-3 bg-blue-50 rounded-xl mb-4 group-hover:scale-110 transition-transform duration-300">
                      <Icon className="h-6 w-6 text-blue-600" />
                    </div>
                    
                    <h4 className="text-lg font-semibold text-gray-900 mb-2">
                      {step.title}
                    </h4>
                    
                    <p className="text-gray-600">
                      {step.description}
                    </p>

                    {index < steps.length - 1 && (
                      <ArrowRight className="hidden lg:block absolute -right-4 top-1/2 transform -translate-y-1/2 text-blue-400 h-6 w-6 group-hover:scale-125 transition-transform duration-300" />
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default MigrationProcess;